<template>
  <div>

    <div class="py-1 mb-2">
      <h3>Search Results For: {{ searchTerm }}</h3>
    </div>

    <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4">
      <b-nav-item :active="curTab === 'inspections'" @click="curTab = 'inspections'" v-if="canViewInspections">
        <i class="fa fa-list"></i>&nbsp; Inspections ({{ inspections.length }})
      </b-nav-item>
      <b-nav-item :active="curTab === 'observations'" @click="curTab = 'observations'" v-if="canViewInspections">
        <i class="fa fa-comment"></i>&nbsp; Observations ({{ observations.length }})
      </b-nav-item>
      <b-nav-item :active="curTab === 'incidents'" @click="curTab = 'incidents'" v-if="canViewIncidents">
        <i class="fa fa-stethoscope"></i>&nbsp; Incidents ({{ incidents.length }})
      </b-nav-item>
      <b-nav-item :active="curTab === 'jobsites'" @click="curTab = 'jobsites'" v-if="canViewJobsites">
        <i class="fa fa-building"></i>&nbsp; Jobsites ({{ jobsites.length }})
      </b-nav-item>
      <b-nav-item :active="curTab === 'actions'" @click="curTab = 'actions'" v-if="canViewCorrectiveActions">
        <i class="fa fa-wrench"></i>&nbsp; Corrective Actions ({{ actions.length }})
      </b-nav-item>
      <b-nav-item :active="curTab === 'subcontractors'" @click="curTab = 'subcontractors'" v-if="canViewSubcontractors">
        <i class="fa fa-id-badge"></i>&nbsp; Subcontractors ({{ subcontractors.length }})
      </b-nav-item>
      <b-nav-item :active="curTab === 'meetings'" @click="curTab = 'meetings'" v-if="canViewSafetyMeetings">
        <i class="fa fa-life-ring"></i>&nbsp; Safety Meetings ({{ meetings.length }})
      </b-nav-item>
    </ul>

    <div v-if="curTab === 'inspections' && canViewInspections">
      <b-card no-body>
        <b-table bordered striped hover :items="inspections" :fields="['InspectionId', 'InspectionDate', 'JobsiteNumber', 'JobsiteName', 'user_name']">
            <template v-slot:cell(InspectionId)="data">
                <router-link :to="`/inspections/view/${data.item.InspectionId}`">View - {{ data.item.InspectionId }}</router-link>
            </template>
            <template v-slot:cell(InspectionDate)="data">
                {{ data.value | moment("MM/DD/YYYY") }}
            </template>
        </b-table>
      </b-card>
    </div>

    <div v-if="curTab === 'observations' && canViewInspections">
      <b-card no-body>
        <b-table bordered striped hover :items="observations" :fields="['observation_date', 'status_name', 'ElementText', 'LastName', 'assignee_name', 'JobsiteName', 'DivisionName',]">
            <template v-slot:cell(InspectionId)="data">
                <router-link :to="`/observations/view/${data.item.observation_id}`">{{ data.item.observation_date | moment("MM/DD/YYYY") }}</router-link>
            </template>
            <template v-slot:cell(status_name)="data">
                <label :class="`badge badge-${data.item.status_color}`">{{ data.item.status_name }}</label>
            </template>

            <template v-slot:cell(ElementText)="data">
                {{ data.item.SectionOrder }}.{{ data.item.ElementOrder }} {{ data.item.ElementText }}
            </template>

            <template v-slot:cell(LastName)="data">
                {{ data.item.FirstName }} {{ data.item.LastName }}
            </template>
            <template v-slot:cell(assignee_name)="data">
                <template v-if="data.item.subcontractor_name">
                    <label class="badge badge-warning small" title="User is a Subcontractor">SUB</label>
                </template>
                {{ data.item.assignee_name }}
                <template v-if="data.item.subcontractor_name">
                    - {{ data.item.subcontractor_name }}
                </template>
            </template>

            <router-link v-slot:cell(JobsiteName)="data" :to="`/jobsites/view/${data.item.jobsite_id}`" title="View Jobsite">
                {{ data.item.JobsiteNumber }} - {{ data.item.JobsiteName }}
            </router-link>

            <template v-slot:cell(DivisionName)="data">
                {{ data.item.division_code }} - {{ data.item.DivisionName }}
            </template>
        </b-table>
      </b-card>
    </div>

    <div v-if="curTab === 'incidents' && canViewIncidents">
      <b-card no-body>
        <b-table bordered striped hover :items="incidents" :fields="['IncidentId', 'IncidentDate', 'JobsiteNumber', 'JobsiteName']">
            <template v-slot:cell(IncidentId)="data">
                <router-link :to="`/incidents/view/${data.item.IncidentId}`">View</router-link>
            </template>
            <template v-slot:cell(IncidentDate)="data">
                {{ data.value | moment("MM/DD/YYYY") }}
            </template>
        </b-table>
      </b-card>
    </div>

    <div v-if="curTab === 'jobsites' && canViewJobsites">
      <b-card no-body>
        <b-table bordered striped hover :items="jobsites" :fields="['JobsiteNumber', 'Address', 'City', 'State', 'Zip']">
            <template v-slot:cell(JobsiteNumber)="data">
                <router-link :to="`/jobsites/view/${data.item.JobsiteId}`">{{ data.item.JobsiteNumber }} - {{ data.item.JobsiteName }}</router-link>
            </template>
        </b-table>
      </b-card>
    </div>

    <div v-if="curTab === 'actions' && canViewCorrectiveActions">
      <b-card no-body>
        <b-table bordered striped hover :items="actions" :fields="['corrective_action_id', 'JobsiteNumber', 'JobsiteName', 'status_name', 'detail']">
            <template v-slot:cell(corrective_action_id)="data">
                <router-link :to="`/corrective-actions/view/${data.item.corrective_action_id}`">View</router-link>
            </template>
            <template v-slot:cell(status_name)="data">
                <span :class="`badge badge-${data.item.status_color}`">{{ data.value }}</span>
            </template>
        </b-table>
      </b-card>
    </div>

    <div v-if="curTab === 'subcontractors' && canViewSubcontractors">
      <b-card no-body>
        <b-table bordered striped hover :items="subcontractors" :fields="['subcontractor_name', 'status_name']">
            <template v-slot:cell(subcontractor_name)="data">
                <router-link :to="`/subcontractors/view/${data.item.subcontractor_id}`">{{ data.item.subcontractor_name }}</router-link>
            </template>
            <template v-slot:cell(status_name)="data">
                <span :class="`badge badge-${data.item.status_color}`">{{ data.value }}</span>
            </template>
        </b-table>
      </b-card>
    </div>

    <div v-if="curTab === 'meetings' && canViewSafetyMeetings">
      <b-card no-body>
        <b-table bordered striped hover :items="meetings" :fields="['meeting_date', 'JobsiteNumber', 'meeting_notes']">
            <template v-slot:cell(meeting_date)="data">
                <router-link :to="`/safety-meetings/view/${data.item.safety_meeting_id}`">{{ data.item.meeting_date | moment("MM/DD/YYYY") }}</router-link>
            </template>
            <template v-slot:cell(JobsiteNumber)="data">
                <router-link :to="`/jobsites/view/${data.item.JobsiteId}`">{{ data.item.JobsiteNumber }} - {{ data.item.JobsiteName }}</router-link>
            </template>
            <template v-slot:cell(meeting_notes)="data">
              <span v-html="data.item.meeting_notes"></span>
            </template>
        </b-table>
      </b-card>
    </div>

  </div>
</template>

<script>
export default {

  data: function() {
    return {
      curTab: 'inspections',
      searchTerm: this.$route.params.term,
      incidents: [],
      inspections: [],
      observations: [],
      jobsites: [],
      actions: [],
      subcontractors: [],
      meetings: [],
    }
  },

  computed: {
    canViewInspections()
    {
      return this.$root.hasPermission(['inspections.view.browse', 'inspections.view.own']);
    },

    canViewIncidents()
    {
      return this.$root.hasPermission(['incidents.view.browse', 'incidents.view.own']);
    },

    canViewJobsites()
    {
      return this.$root.hasPermission('jobsites.view');
    },

    canViewCorrectiveActions()
    {
      return this.$root.hasPermission(['correctiveActions.view.browse', 'correctiveActions.view.assigned']);
    },

    canViewSubcontractors()
    {
      return this.$root.hasPermission('subcontractors.view');
    },

    canViewSafetyMeetings()
    {
      return this.$root.hasPermission(['safety.meetings.view.browse', 'safety.meetings.view.own']);
    }
  },

  methods: {
    //Initial Starter Function
    doSearch(){
      //Chain all the searchs together
      if(this.canViewInspections)
      {
          this.searchInspections();
          this.searchObservations();
      }

      //Check permissions
      if(this.canViewIncidents)
      {
        //Get the incidents
        this.searchIncidents();
      }

      //Check permissions
      if(this.canViewJobsites)
      {
        //Get the jobsites
        this.searchJobsites();
      }

      //Check permissions
      if(this.canViewCorrectiveActions)
      {
        //Get the actions
        this.searchCorrectiveActions();
      }

      //Check permissions
      if(this.canViewSubcontractors)
      {
        //Get the actions
        this.searchSubcontractors();
      }

      //Check permissions
      if(this.canViewSafetyMeetings)
      {
        //Get the actions
        this.searchSafetyMeetings();
      }
    },

    //Search the Inspections
    searchInspections(){
      //Loading Indicator?

      //Send ti
      this.$http.get('/inspections/list?query='+this.searchTerm)
        .then(response => {
          //Set the data
          this.inspections = response.data.data;
        })
        .catch(err => {})
        .then(response => {

        })
    },

    //Search the Inspections
    searchObservations(){
      //Loading Indicator?

      //Send ti
      this.$http.get('/observations/list?query='+this.searchTerm)
        .then(response => {
          //Set the data
          this.observations = response.data.data;
        })
        .catch(err => {})
        .then(response => {

        })
    },

    //Get Search Data
    searchIncidents(){
      //Loading Indicator?

      //Send ti
      this.$http.get('/incident/list?query='+this.searchTerm)
        .then(response => {
          //Set the data
          this.incidents = response.data.data;
        })
        .catch(err => {})
        .then(response => {

        });
    },

    //Search the Jobsites
    searchJobsites(){

      //Send ti
      this.$http.get('/jobsite/list?query='+this.searchTerm)
        .then(response => {
          //Set the data
          this.jobsites = response.data.data;
        })
        .catch(err => {})
        .then(response => {

        });
    },

    searchCorrectiveActions(){

      //Send ti
      this.$http.get('/corrective-actions/list?query='+this.searchTerm)
        .then(response => {
          //Set the data
          this.actions = response.data.data;
        })
        .catch(err => {})
        .then(response => {

        });
    },

    searchSubcontractors(){

      //Send ti
      this.$http.get('/subcontractors/list?query='+this.searchTerm)
        .then(response => {
          //Set the data
          this.subcontractors = response.data.data;
        })
        .catch(err => {})
        .then(response => {

        });
    },

    searchSafetyMeetings(){

      //Send ti
      this.$http.get('/safety-meetings/list?query='+this.searchTerm)
        .then(response => {
          //Set the data
          this.meetings = response.data.data;
        })
        .catch(err => {})
        .then(response => {

        });
    },

    searchHSEs(){},
  },

  mounted(){
    //Start the Chained Search
    this.doSearch()
  }
}
</script>
